import { Loading } from '@/components/loading/loading.component';
import { Body3 } from '@/components/typography';
import { H3 } from '@/components/typography/heading/headings.component';
import { cn } from '@/lib/utils';
import { useOrganicMatterData } from '@/modules/Report/Report.api';
import { toast } from 'react-toastify';

export const OrganicMatterChart = ({ fieldId }: { fieldId: string }) => {
  const { data: organicMatterData, status } = useOrganicMatterData(fieldId);

  if (status === 'pending') return <Loading />;
  if (status === 'error') {
    toast.error('Failed to fetch soil organic matter data');
    return null;
  }

  if (!organicMatterData?.chart) {
    return null;
  }

  return (
    <div>
      <H3 className={cn('mb-4')}>Organo-Mineral Soil Texture</H3>
      <div className={cn('flex flex-col items-center')}>
        <div className={cn('flex justify-center w-full')}>
          <img src={`data:image/png;base64,${organicMatterData.chart}`} alt="Organic Matter Chart" className="w-full max-w-3xl h-auto" />
        </div>
        <div className={cn('bg-neutral-200 rounded-lg px-6 py-1 mt-2 w-full max-w-md ml-[10px]')}>
          <Body3 className={cn('text-neutral-600 mb-1 text-center')}>*If less than 50% sand in the mineral fraction</Body3>
          <Body3 className={cn('text-neutral-600 text-center')}>†If 50% sand or more in the mineral fraction</Body3>
        </div>
      </div>
    </div>
  );
};
